module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAAA/BAMAAADkhXBTAAAAD1BMVEX////jQ2PcFDzuip7////0clvrAAAAAnRSTlO/7yV7gKYAAAAwSURBVHicY2QgGTC6jGoZ1TKqZVTLqJYRpsWYdC1Ko1pGtYxqGdUyqmWEaREkWQsAYPMMeAxx35kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/pl.png
// module id = lGp/
// module chunks = 0